module.exports = __webpack_public_path__ + "static/media/social-instagram.e7dcc806.webp";